import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function modificarCertificado (payload = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getCompanytemplate)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/wizard/modificarcertificado',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: payload,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { modificarCertificado }
